import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import CheckRegistrationForm from '../../components/CheckRegistration/CheckRegistrationForm';
import CssTransition from '../../components/Transition/CssTransition';
import LegalInfo from '../../components/Widget/LegalInfo';
import ToasterAlert from '../../components/Donation/ToasterAlert';
import TransitionContainer from '../../components/Transition/TranstionContainer';
import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import {
    ContainerStyled,
    FormWrapper
} from '../../containers/DefaultStyles/AssessmentDetails';

import {
    onGoToNextCard,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';
import { onGoToStartScreen, submitCheckRegistrationForm } from './actions';
import { cacheFormData } from '../../utils/formCaching/actions';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes } from '../../utils/enums';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';

const CheckRegistrationDetails = props => (
    <TransitionContainer isSubmitting={props.isFormSubmitting} zIndex={2}>
        <ContainerStyled>
            <VoteRegistrationSidebar
                title={props.customHeader}
                showReceiveUpdates={true}
            />
            <FormWrapper>
                <CheckRegistrationForm
                    hasABOptIn={props.hasABOptIn}
                    hasPartnerOptIn={props.hasPartnerOptIn}
                    partnerOptInText={props.partnerOptInText}
                    subscriptionOptInText={props.subscriptionOptInText}
                    onBack={() => {
                        props.setExitingCardProps(
                            'checkRegistration',
                            props,
                            props.activeAction
                        );
                        props.onGoToStartScreen(props.actionIdentifier);
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.setExitingCardProps(
                            'checkRegistration',
                            props,
                            props.activeAction
                        );
                        if (props.skipEndCard) {
                            props.handleSkippingEndCard(
                                props.nextAction,
                                props.cards,
                                props.onGoToNextCard
                            );
                        }
                        props.submitCheckRegistrationForm(
                            props.apiRequestData,
                            values,
                            props.isMultiActionsCard,
                            props.actionIdentifier,
                            props.actionCompletedTime(),
                            props.skipEndCard
                        );
                    }}
                    isFormSubmitting={props.isFormSubmitting}
                />
                {props.isMobileResolution && <LegalInfo style={{ paddingTop: '10px' }} />}
            </FormWrapper>
            <TransitionGroup>
                {props.checkRegistrationError && (
                    <CssTransition key="alert" in={props.checkRegistrationError}>
                        <ToasterAlert content={props.checkRegistrationError} />
                    </CssTransition>
                )}
            </TransitionGroup>
        </ContainerStyled>
    </TransitionContainer>
);

CheckRegistrationDetails.propTypes = {
    actionCompletedTime: PropTypes.func.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    activeAction: PropTypes.object.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    cacheFormData: PropTypes.func.isRequired,
    cards: PropTypes.array.isRequired,
    checkRegistrationError: PropTypes.string,
    customHeader: PropTypes.string,
    hasABOptIn: PropTypes.bool.isRequired,
    hasPartnerOptIn: PropTypes.bool.isRequired,
    partnerOptInText: PropTypes.string,
    handleSkippingEndCard: PropTypes.func.isRequired,
    isFormSubmitting: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    isMultiActionsCard: PropTypes.bool.isRequired,
    nextAction: PropTypes.object,
    onGoToNextCard: PropTypes.func.isRequired,
    onGoToStartScreen: PropTypes.func.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    skipEndCard: PropTypes.bool,
    submitCheckRegistrationForm: PropTypes.func.isRequired,
    subscriptionOptInText: PropTypes.string
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'checkRegistration',
            ['/checkRegistration/details'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            actionCompletedTime: getActionCompletedTime(state, 'checkRegistration'),
            actionIdentifier: state.widget.activeAction.identifier,
            activeAction: state.widget.activeAction,
            apiRequestData: state.widget.apiRequestData,
            cards: state.widget.cards,
            hasABOptIn: !state.widget.activeAction.hideSubscriptionOptIn,
            hasPartnerOptIn: state.widget.activeAction.hasPartnerOptIn || false,
            partnerOptInText:
                state.widget.activeAction.partnerOptInText ||
                (state.widget.activeAction.partner || {}).name,
            subscriptionOptInText: state.widget.activeAction.subscriptionOptInText || '',
            checkRegistrationError: state.checkRegistration.checkRegistrationError,
            customHeader:
                state.widget.activeAction.customHeader || `Check your registration.`,
            isFormSubmitting: state.checkRegistration.isFormSubmitting,
            isMobileResolution: state.widget.isMobileResolution,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            nextAction,
            skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction
        };
    },
    {
        cacheFormData,
        handleSkippingEndCard,
        onGoToNextCard,
        onGoToStartScreen,
        setExitingCardProps,
        submitCheckRegistrationForm
    }
)(CheckRegistrationDetails);
